import { Search } from "../Search";
import { CardSearchContainer } from "./style";

export const CardSearch = () => {
  return (
    <CardSearchContainer>
      <Search title={"Está buscando um endereço?"} />
    </CardSearchContainer>
  );
};
